import styled from 'styled-components';
import { getTheme, ifProp } from 'mol-ui';

export const Container = styled.div`
    height: ${ ifProp('success', '200px', '400px') };
    width: 100%;
`;

export const Text = styled.div`
    color: ${ getTheme('textColor') };
    font-size: 12px;
    text-align: center;
`;
